import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';
import { ChargeAttemptStatistics } from '../../types/payment.types';

interface PaymentStatisticsCardsProps {
  statistics: ChargeAttemptStatistics | undefined;
  isLoading: boolean;
}

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(num);
}

function PaymentStatisticsCards({ statistics, isLoading }: PaymentStatisticsCardsProps) {
  const cards = [
    {
      title: 'Successful Charges',
      value: statistics ? formatNumber(statistics.totalSuccessfulCount) : '-',
      variant: 'success'
    },
    {
      title: 'Failed Charges',
      value: statistics ? formatNumber(statistics.totalFailedCount) : '-',
      variant: 'danger'
    },
    {
      title: 'Total Collected',
      value: statistics ? formatCurrency(statistics.totalSuccessfulAmount) : '-',
      variant: 'primary'
    },
    {
      title: 'Failed Amount',
      value: statistics ? formatCurrency(statistics.totalFailedAmount) : '-',
      variant: 'warning'
    }
  ];

  return (
    <Row className="g-3 mb-4">
      {cards.map((card, index) => (
        <Col key={index} xs={6} lg={3}>
          <Card className={`border-${card.variant} h-100`}>
            <Card.Body className="text-center">
              <Card.Subtitle className="mb-2 text-muted">{card.title}</Card.Subtitle>
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <Card.Title className={`text-${card.variant} fs-3 mb-0`}>{card.value}</Card.Title>
              )}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default PaymentStatisticsCards;
